import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';

import { IS_API_GATEWAY, IS_PRIVATE_API } from '@personal-area/common';

import { PROMO_LIST } from '../constants/promo-list';
import { BonusStats } from '../models/bonus-stats';
import { knownPromos, Promo } from '../models/promo';
import { VpsServer } from '../models/vps-server';

const promoURLs = {
  bonusStats: (bonus: string) => `/2/v2/${bonus}/info`,
  openOrders: (userId: number, accountId: number) =>
    `/v1/users/${userId}/accounts/${accountId}/open-orders`,
  vps: () => `/v1/vps/servers`,
};

@Injectable({ providedIn: 'root' })
export class PromoApiService {
  private _http = inject(HttpClient);

  public getPromos(): Observable<Promo[]> {
    return of(PROMO_LIST);
  }

  public getBonusStats(bonus: string): Observable<BonusStats | VpsServer> {
    switch (bonus) {
      case knownPromos.vps:
        return this._http
          .get<{ items: VpsServer[] }>(promoURLs.vps(), {
            context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
          })
          .pipe(
            map(
              (data: { items: VpsServer[] }) =>
                data.items.filter((item) => item.status !== 'closed')[0],
            ),
          );

      default:
        return this._http.get<BonusStats>(promoURLs.bonusStats(bonus), {
          context: new HttpContext().set(IS_PRIVATE_API, true),
        });
    }
  }

  public getOpenOrders(
    userId: number,
    accountId: number,
  ): Observable<{ orders: number; positions: number }> {
    return this._http.get<{ orders: number; positions: number }>(
      promoURLs.openOrders(userId, accountId),
      { context: new HttpContext().set(IS_PRIVATE_API, true) },
    );
  }
}
